import { API } from './callAPI';
import imageCompression from 'browser-image-compression';
import Env from './Env';

// Upload un fichier vers un S3 via une url signée
// Upload un fichier vers un S3 via une URL signée
export function uploadToS3(name: string, fileType: string, blob: Blob) {
  return new Promise(async (resolve, reject) => {
    try {

      // 0. Parametrage
      const photoSizeToCompress = Env.REACT_APP_PHOTO_SIZE_TO_COMPRESS;
      const photoMaxSize = Env.REACT_APP_PHOTO_MAX_SIZE;
      const photoMaxWidthOrHeight = Env.REACT_APP_PHOTO_MAX_WIDTH_OR_HEIGHT;

      console.log(`Compress - photoSizeToCompress: ${photoSizeToCompress}`);
      console.log(`Compress - photoMaxSize: ${photoMaxSize}`);
      console.log(`Compress - photoMaxWidthOrHeight: ${photoMaxWidthOrHeight}`);

      // 1. Convertir Blob → File
      const file = new File([blob], name, {
        type: blob.type,
        lastModified: Date.now()
      });

      // 2. Options de compression
      const options = {
        maxSizeMB: photoMaxSize,
        maxWidthOrHeight: photoMaxWidthOrHeight,
        useWebWorker: true,
      };

      const fileSize = file.size / 1024 / 1024;
      console.log(`Compress - File: ${name}`);
      console.log(`Compress - Size before: ${fileSize.toFixed(2)} Mo`);

      // 3. Compression
      let workFile;

      if (fileSize > photoSizeToCompress) {
        console.log(`Compress - Running compression on ${name}`);
        workFile = await imageCompression(file, options);
        console.log(`Compress - Size after: ${(workFile.size / 1024 / 1024).toFixed(2)} Mo`);
      } else {
        workFile = file;
      }

      // 4. Récupération de l'URL signée
      const { data } = await API.getSignedtUrlS3(name, 'PUT');

      // 5. Upload vers S3
      if (data?.uploadUrl) {
        const response = await uploadFileToS3(data.uploadUrl, workFile, fileType);
        console.log(`Upload terminé avec succès pour : ${name}`);
        resolve(response);
      } else {
        const errDescription = `Erreur lors de l'upload du fichier ${name} url non renseigné:`;
        console.error(errDescription);
        reject(errDescription);
      }

    } catch (error) {
      console.error(`Erreur lors de l'upload du fichier ${name} :`, error);
      reject(error);
    }
  });
}


// Upload un fichier vers un S3 via une url signée
const uploadFileToS3 = (url: string, blob: Blob, _type: string) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", url, true);
    xhr.send(blob);
    xhr.onload = function() {
      this.status === 204 || this.status === 200 ? resolve("file uploaded !") : reject(this.responseText);
    };
  });
}

export async function getPictureFromS3(name: string) {
  return new Promise((resolve, reject) => {
    var promise = API.getSignedtUrlS3(name, 'GET');
    promise.then((url: any) => {
      console.log('get Image : ' + name);
    
      resolve(url);
    }, (err: any) => {
      console.log(err);
      reject(err);
    });
  })
}
